module.exports = __webpack_public_path__ + "static/matrix-myth-fc27fcc0af7c288b072f89188a6d47c1.png";